import React, { useState, useEffect } from "react"
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@material-ui/core';

import SelectedBlueIcon from "../../images/selected-blue.svg"
import CloseIcon from '@material-ui/icons/Close';

import { allQuestions, smoothieTypes } from "../../pages/Home.js"
import { DefaultContainer, TitleAndSubTitle, Stepper, Footer} from "./Step1.js"

import APIS from "../../utils/APIS"

const Step8 = ({step, setStep, reps, setReps}) => {

  const [haveConfirm, setHaveConfirm] = useState(false)

  const [modalChange, setModalChange] = useState(false)

  const [modifSmoothieID, setModifSmoothieID] = useState(reps?.smoothieChoiceID)

  const findReps = (sID, qID) => {
    //allQuestions?.step1?.questions[reps?.q1]?.title
    let questions = allQuestions[sID]?.questions
    let rep = reps[qID]
    return questions[rep]?.forEnd
  }


  return (
    <>
      <DefaultContainer>
        {/*<Stepper step={step}/>*/}

        {/*<TitleAndSubTitle
          title={allQuestions?.step8?.title}
          subTitle={allQuestions?.step8?.subTitle}
        />*/}

        {/* CENTER */}
        <Box sx={{flex:1, marginTop:"0px", display:"flex", flexDirection:"column", alignItems:"center", paddingLeft:"105px", paddingRight:"105px"}}>
          <Box sx={{
            width:"100%",
            borderRadius:"24px",
            height:"1300px",
            display:"flex",
            flexDirection:"column",
            gap:"40px",
            background: "rgba(255, 255, 255, 0.8)",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            boxShadow: "0px 16px 32px rgba(59, 102, 245, 0.06)",
            padding:"40px",
            marginTop:"200px",
          }}>
            <Box sx={{
              fontSize:"48px",
              fontWeight:600,
              color:"#475569"
            }}>
              <font style={{textTransform:"capitalize", fontWeight:"bold"}}>{reps?.name}</font>, votre Smoothie <font style={{color:"#4285F4"}}>Généré par Gemini</font> est ...
            </Box>
            <Box sx={{
              fontSize:"100px",
              fontWeight:600,
              color:"primary.main",
              width:"100%",
              textAlign:"center",
              marginBottom:"40px",
              marginTop:"20px",
            }}>
              {smoothieTypes?.find((el) => el?.id === reps?.smoothieChoiceID)?.name}
            </Box>
            <Box sx={{
              fontSize:"35px",
              fontWeight:600,
              color:"#475569",
              width:"100%",
              padding:"0px 50px",
              textAlign:"center"
            }}>
              {smoothieTypes?.find((el) => el?.id === reps?.smoothieChoiceID)?.desc1}
            </Box>
            <Box sx={{
              width:"100%",
              display:"flex",
              alignItems:"center",
              justifyContent:"center",
              marginTop:"10px",
              marginBottom:"10px",
            }}>
              <Box sx={{
                //border:"1px solid black",
                width:"660px",
                height:"660px",
                backgroundImage: `url(${smoothieTypes?.find((el) => el?.id === reps?.smoothieChoiceID)?.image})`,
                backgroundSize:"contain",
                backgroundRepeat:"no-repeat",
                backgroundPosition:"center center",
                //backgroundColor:"#b6ddf2",
              }}>
              </Box>
            </Box>
            <Box sx={{
              fontSize:"30px",
              fontWeight:500,
              color:"#475569",
              width:"100%",
              padding:"0px 0px",
              textAlign:"center"
            }}>
              {smoothieTypes?.find((el) => el?.id === reps?.smoothieChoiceID)?.desc2}
            </Box>
          </Box>

          <Box sx={{
            width:"100%",
            borderRadius:"24px",
            height:"180px",
            display:"flex",
            flexDirection:"row",
            gap:"20px",
            background: "rgba(255, 255, 255, 0.8)",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            boxShadow: "0px 16px 32px rgba(59, 102, 245, 0.06)",
            padding:"15px",
            marginTop:"50px"
          }}>
            <Box sx={{
              fontSize:"33px",
              fontWeight:"500",
              fontStyle:"italic",
              color:"#94A3B8",
              paddingLeft:"10px",
              paddingTop:"10px"
            }}>
              1x {smoothieTypes?.find((el) => el?.id === reps?.smoothieChoiceID)?.name}<br/>
              Base : {findReps("step5", "q5")} + {findReps("step6", "q6")}<br/>
              Option : {findReps("step4", "q4")} <br/>
            </Box>
          </Box>

          {haveConfirm === false ? (
            <Box sx={{display:"flex", width:"80%", justifyContent:"space-between", marginTop:"480px",}}>
              <Button
                variant="contained"
                sx={{
                  minWidth:"500px",
                  minHeight:"120px",
                  height:"100px",
                  background:"lightgrey",
                  color:"white",
                  boxShadow: "0px 10px 15px #EEEEEE",
                  "&:hover": {
                    background:"grey",
                    boxShadow: "0px 10px 15px #EEEEEE",
                  },
                }}
                onClick={() => { setModalChange(true) }}
              >
                Modifier
              </Button>
              <Button
                variant="contained"
                sx={{
                  minWidth:"500px",
                  minHeight:"120px",
                  height:"100px"
                }}
                onClick={() => {
                  setHaveConfirm(true)
                  //on envoie vers le back
                  let addVals = {
                    name : reps?.name,
                    typeID : reps?.smoothieChoiceID,
                    status : "toDo",
                    reps : JSON.stringify(reps)
                  }
                  APIS.addOrder(addVals).then((result) => {
                    //console.log(result)
                    if (result?.message !== "addOrder") {
                      console.log("erreur add")
                      alert("Une erreur est survenue")
                    }
                  })
                }}
              >
                Commander
              </Button>
            </Box>
          ) : (
            <Box sx={{marginTop:"120px", fontSize:"45px", fontWeight:"500", textAlign:"center", }}>
              Votre commande a bien été envoyée ! <br/>
              Elle est actuellement en préparation et sera bientôt<br/>
              prête à être récupérée.
            </Box>
          )}

          <Dialog open={modalChange} onClose={() => {setModalChange(false)}} fullWidth={true} maxWidth={"xl"}>
            <DialogContent style={{marginTop:"5px", marginBottom:"10px"}}>
              <Box sx={{display:"flex", justifyContent:"space-between", marginBottom:"100px"}}>
                <Box sx={{width:"50px", height:"50px"}} />
                <Box sx={{fontSize:"70px", fontWeight:600, color:"primary.main"}}>
                  Choisis ton smoothie
                </Box>
                <Box sx={{width:"50px", height:"50px", cursor:"pointer"}} onClick={() => {setModalChange(false)}}>
                  <CloseIcon sx={{height:"50px", width:"50px"}}/>
                </Box>
              </Box>

              <Box sx={{flex:1, display:"flex", justifyContent:"center", paddingLeft:"60px", paddingRight:"60px"}}>
                <Box sx={{width:"100%", display:"flex", flexDirection:"row", flexWrap:"wrap", gap:"50px", alignContent:"flex-start"}}>
                  {smoothieTypes?.map((elem, index) => {
                    let selected = false
                    if (elem?.id === modifSmoothieID) { selected = true }
                    return (
                      <Box
                        key={index}
                        onClick={() => {
                          console.log(elem?.id)
                          setModifSmoothieID(elem?.id)
                          //setReps({...reps, q2 : index})
                        }}
                        sx={{
                          flexBasis:'calc(50% - 25px)',
                          flexShrink:0,
                          height:"320px",
                          background: selected ? "#F9F9FC" : "#F3F3F6",
                          border: selected ? "4px solid #174EA6" : "3px solid #C7C4D7",
                          boxShadow: selected ? "0px 10px 30px rgba(93, 95, 239, 0.12)" : "",
                          borderRadius: "24px",
                          //cursor:"pointer",
                          display:"flex",
                          alignItems:"center",
                          justifyContent:"center",
                          position:"relative"
                        }}
                      >
                        {selected &&
                          <Box sx={{
                            position:"absolute",
                            width:"47px",
                            height:"47px",
                            top:"20px",
                            right:"20px",
                          }}>
                            <img src={SelectedBlueIcon} />
                          </Box>
                        }
                        <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:"10px"}}>
                          <Box sx={{
                            width:"150px",
                            height:"100px",
                            backgroundImage: `url(${elem?.image})`,
                            backgroundSize:"contain",
                            backgroundRepeat:"no-repeat",
                            backgroundPosition:"center center",
                            marginBottom:"10px"
                          }} />
                          <Box sx={{
                            fontSize:"45px",
                            fontWeight:"600",
                            color : selected ? "text.secondary" : "text.primary",
                            textAlign:"center",
                          }}>
                            {elem?.name}
                          </Box>
                          <Box sx={{
                            fontSize:"23px",
                            fontWeight:"500",
                            color : selected ? "text.secondary" : "#464555",
                            textAlign:"center",
                            padding:"0px 50px"
                          }}>
                            {elem?.desc1}
                          </Box>
                        </Box>
                      </Box>
                    )
                  })}
                </Box>
              </Box>

              <Box sx={{display:"flex", justifyContent:"center", marginTop:"100px", marginBottom:"10px"}}>
                <Button
                  variant="contained"
                  sx={{
                    minWidth:"500px",
                    minHeight:"120px",
                    height:"100px"
                  }}
                  onClick={() => {
                    setReps({...reps, smoothieChoiceID : modifSmoothieID})
                    setModalChange(false)
                  }}
                >
                  Modifier
                </Button>
              </Box>
            </DialogContent>
          </Dialog>

        </Box>

        {haveConfirm === true &&
          <Footer
            onClick={() => { setStep(0) }}
            returnToHome
          />
        }

      </DefaultContainer>
    </>
  );
};

export default Step8;
